<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter15">
<h1><a id="page_33"></a><a href="#/003toc#ch15">White Bean and Rosemary Soup</a></h1>
<p class="noindent">Creamy, tender white beans, chunks of spicy Capicola or other ham, and rosemary combine for a hearty soup that is terrific to serve for lunch or as part of a soup-andsandwich supper. Try serving this soup with grown-up grilled cheese—panini made with fontina, provolone, and fresh mozzarella topped with pesto. Now that’s a great meal!</p>
<p class="noindent">3 tablespoons extra-virgin olive oil</p>
<p class="noindent">4 ounces of spicy Italian ham or Capicola, cut into ½-inch dice</p>
<p class="noindent">1 medium onion, finely chopped</p>
<p class="noindent">2 cloves garlic, minced</p>
<p class="noindent">3 stalks celery with leaves, finely chopped</p>
<p class="noindent">3 medium carrots, finely chopped</p>
<p class="noindent">2 teaspoons finely minced fresh rosemary</p>
<p class="noindent">One 14- to 15-ounce can plum tomatoes, crushed and drained</p>
<p class="noindent">2 cups dried beans, picked over for stones, soaked, or two 14- to 15-ounce cans small white beans, drained and rinsed</p>
<p class="noindent">6 cups chicken or vegetable broth</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">heat the oil in a skillet over medium-high heat.</p>
<p class="noindent">add the ham and sauté until it begins to get crisp, about 3 minutes. Add the onion, garlic, celery, carrots, and rosemary and sauté until the vegetables begin to soften, about 3 minutes. Add the tomatoes and stir to combine.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Stir in the beans and the broth.</p>
<p class="noindent">cover the slow cooker and cook on low for 8 to 9 hours, until the beans are tender. Season with salt and pepper before serving.</p>
<p class="noindent">serves 8</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 021-chapter15.vue?6b738310